export default "__VITE_ASSET__7kDIuuMC__"